export default "__VITE_ASSET__uDJS3nbp__"